module.exports={
	"Form": "DocumentViewManifest",
	"Descriptors": {
		"DocumentDetails.Name": {
			"Name": "Name",
			"Hash": "ViewDocumentName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentView",
				"Group": "DocumentView"
			}
		},
		"DocumentType": {
			"Name": "Type",
			"Hash": "ViewDocumentDocumentType",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentView",
				"Group": "DocumentView",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.TempRNI.Name~}",

					"EmptyValueTestList": ["AppData.TempRNI"],
					"EmptyValueTemplate": "N/A",

					"EntitiesBundle": [
						{
							"Entity": "ReportNamedInstance",
							"Filter": "FBV~IDCustomer~EQ~{~D:AppData.DocumentDetails.IDCustomer~}~FBV~Hash~EQ~{~D:AppData.DocumentDetails.DocumentType~}",
							"Destination": "AppData.TempRNI",
							"SingleRecord": true
						}]
				}
			}
		},
		"DocumentDetails.CreatingIDUser": {
			"Name": "Created By",
			"Hash": "ViewDocumentCreatingIDUser",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "DocumentView",
				"Group": "DocumentView",
				"Entity": "User"
			}
		},
		"DocumentDetails.DocumentDate": {
			"Name": "Document Date",
			"Hash": "ViewDocumentDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "2",
				"Section": "DocumentView",
				"Group": "DocumentView"
			}
		},
		"DocumentDetails.IDProject": {
			"Name": "Project",
			"Hash": "ViewDocumentIDProject",
			"DataType": "String",
			"PictForm": {
				"Row": "3",
				"InputType": "Picker",
				"Section": "DocumentView",
				"Group": "DocumentView",
				"Entity": "Project"
			}
		},
		"DocumentDetails.StatusDisplay": {
			"Name": "Status",
			"Hash": "ViewDocumentStatus",
			"DataType": "String",
			"PictForm": {
				"Row": "3",
				"Section": "DocumentView",
				"Group": "DocumentView"
			}
		}
	},
	"Sections": [
		{
			"Name": "Document View",
			"Hash": "DocumentView",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Document View",
					"Hash": "DocumentView",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
